// src/pages/Splash.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Splash = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 1500); // 1.5 segundos

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section className="hero is-fullheight is-link">
      <div className="hero-body">
        <div className="container has-text-centered">
          <h1 className="title is-2 has-text-white">✅ Acceso concedido</h1>
          <p className="subtitle is-5 has-text-light">Cargando dashboard...</p>
        </div>
      </div>
    </section>
  );
};

export default Splash;
